import { GestionTarea } from '../../model/gestion-tarea/gestion-tarea';

/**
 * Puerto de Dominio: GestionTareaRepository
 * 
 * Define el contrato para acceso a datos del historial y gestión de tareas.
 * Implementado por HttpGestionTareaRepository en infraestructura.
 * 
 * Legacy Reference:
 * - CallsHistoryInterfaceImpl.java (UI historial)
 * - CallManagementInterfaceImpl.java (UI ingresar gestión)
 * - CallsManagementHandler.java (backend)
 * 
 * Backend: /api/servicios/gestiones-tareas
 * 
 * @author Sura - Migración GWT a Spring Boot
 */
export abstract class GestionTareaRepository {

  // === Historial de Gestiones ===

  /**
   * Consulta el historial de gestiones para un detalle de orden de servicio.
   * 
   * GET /api/servicios/gestiones-tareas/historial/{nmconsecutivo}
   * 
   * Legacy: CallsHistoryInterfaceImpl.java, CallsManagementHandler.searchCallsManagementHistory()
   * Tabla: TPSC_GESTION_LLAMADAS LEFT JOIN TPSC_RESPUESTA_LLAMADAS
   * 
   * @param nmconsecutivoDetalle Consecutivo del detalle de orden de servicio
   * @returns Lista de gestiones ordenadas por fecha descendente
   */
  abstract consultarHistorialGestiones(
    nmconsecutivoDetalle: number
  ): Promise<GestionTarea[]>;

  // === Ingresar Gestión ===

  /**
   * Guarda una gestión de tarea para múltiples órdenes.
   * 
   * POST /api/servicios/gestiones-tareas
   * 
   * Legacy: CallManagementActivity.ingresarGestion(), CallsManagementHandler.saveOrUpdateCalls()
   * Tabla: TPSC_GESTION_LLAMADAS
   * 
   * @param request Datos de la gestión
   * @returns Objeto con resultado de la operación
   */
  abstract guardarGestiones(
    request: GuardarGestionTareaRequest
  ): Promise<{ exito: boolean; mensaje?: string }>;
}

/**
 * Request para guardar gestión de tarea.
 * 
 * Legacy: Tpsc_gestion_llamadasdto.java
 */
export interface GuardarGestionTareaRequest {
  /** Consecutivos de las órdenes seleccionadas */
  nmconsecutivosOrden: number[];
  
  /** Fecha de la gestión (YYYY-MM-DD) */
  fechaLlamada: string;
  
  /** Hora de la gestión (HH:mm) */
  horaLlamada: string;
  
  /** Persona que responde */
  personaResponde: string;
  
  /** Consecutivo de la respuesta */
  nmconsecRespuestaLlamada: number;
  
  /** Fecha de nueva gestión (si aplica - YYYY-MM-DD) */
  fechaNuevaLlamada?: string;
  
  /** Hora de nueva gestión (si aplica - HH:mm) */
  horaNuevaLlamada?: string;
  
  /** Consecutivo del tipo de canal */
  nmconsecTipoCanal: number;
  
  /** Motivo del reporte (si aplica - código 21) */
  motivoReporte?: string;
  
  /** Observaciones/Notas de la gestión */
  observaciones?: string;
  
  /** Usuario que registra */
  usuarioRegistra?: string;
  
  /** Nombre del archivo de evidencia (DSEVIDENCIA) */
  nombreEvidencia?: string;
  
  /** Contenido del archivo en Base64 (DSEVIDENCIA_B) */
  evidenciaBase64?: string;
}
